/* eslint-disable @typescript-eslint/no-explicit-any */
import { Helmet } from 'react-helmet'
import { Progress, Table, Button } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { StyledLayout } from './Projects.styles'
import { TopBar } from '../../components'
import { IRow } from './Projects.types'
import { useAppSelector, useAppDispatch } from '../../store/hooks'
import { fetchUser } from '../../store/slices/user/user'

const { Column } = Table

const Projects: React.FC = (): JSX.Element => {
    const history = useHistory()
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(fetchUser())
    }, [dispatch])

    const user = useAppSelector((state) => state.user!)
    const { projects } = user
    const data: IRow[] = projects.map(
        (
            project: {
                updatedAt: any
                patentName: any
                description: any
                serviceCall: any
                progress: any
            },
            index: number
        ) => {
            const date = new Date(parseInt(project.updatedAt ?? 0, 10) * 1000)
            const formattedDate = `
            ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} ${
                date.getMonth() + 1
            }/${date.getDate()}/${date.getFullYear()}`
            return {
                id: index + 1,
                patent_name: project.patentName,
                description: project.description,
                service_calls: project.serviceCall,
                progress: project.progress ?? 0,
                last_update: formattedDate,
            }
        }
    )
    return (
        <StyledLayout>
            <Helmet title="Projects" />
            <Content style={{ padding: '0 50px' }}>
                <TopBar breadcrumb={['Projects']}>
                    <Button type="primary">
                        <Link to="/projects/new">New project</Link>
                    </Button>
                </TopBar>
                <Table
                    dataSource={data}
                    tableLayout="fixed"
                    onRow={(r) => ({
                        onClick: () => history.push(`/projects/${r.id}`),
                    })}
                >
                    <Column
                        title="#"
                        dataIndex="id"
                        key="id"
                        width="5%"
                        sorter={(a: any, b: any) => {
                            if (a && b) {
                                return a.id - b.id
                            }
                            return 0
                        }}
                        sortDirections={['descend', 'ascend']}
                    />
                    <Column
                        title="Patent name"
                        dataIndex="patent_name"
                        key="patent_name"
                        width="20%"
                        sorter={(a: any, b: any) => {
                            if (a && b) {
                                const aName = a.patent_name || ''
                                const bName = b.patent_name || ''
                                return aName.localeCompare(bName)
                            }
                            return ''
                        }}
                        sortDirections={['descend', 'ascend']}
                        onCell={() => ({
                            style: {
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                overflowWrap: 'anywhere',
                            },
                        })}
                    />
                    <Column
                        title="Description"
                        dataIndex="description"
                        key="description"
                        width="30%"
                        sorter={(a: any, b: any) => {
                            if (a && b) {
                                const aDescription = a.description || ''
                                const bDescription = b.description || ''
                                return aDescription.localeCompare(bDescription)
                            }
                            return ''
                        }}
                        sortDirections={['descend', 'ascend']}
                        onCell={() => ({
                            style: {
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                overflowWrap: 'anywhere',
                            },
                        })}
                    />
                    <Column
                        title="Service calls"
                        dataIndex="service_calls"
                        key="service_calls"
                        width="15%"
                        sorter={(a: any, b: any) => {
                            if (a && b) {
                                const aServiceCalls = a.service_calls || ''
                                const bServiceCalls = b.service_calls || ''
                                return aServiceCalls.localeCompare(
                                    bServiceCalls
                                )
                            }
                            return ''
                        }}
                        sortDirections={['descend', 'ascend']}
                    />
                    <Column
                        title="Progress"
                        dataIndex="progress"
                        key="progress"
                        width="15%"
                        render={(progress) => <Progress percent={progress} />}
                        sorter={(a: IRow, b: IRow) => {
                            if (a && b) {
                                return a.progress - b.progress
                            }
                            return 0
                        }}
                        sortDirections={['descend', 'ascend']}
                    />
                    <Column
                        title="Last update"
                        dataIndex="last_update"
                        key="last_update"
                        width="15%"
                    />
                </Table>
            </Content>
        </StyledLayout>
    )
}

export default Projects
